import React from 'react';

type Props = {
  data: any;
};

const DomicilioCard: React.FC<Props> = ({ data }) => {
  if (!data) return null;

  const isHogar =
    data?.customer?.typeService?.name?.toLowerCase().includes('hogar') ||
    data?.customer?.typeService?.code === 'HO' ||
    data?.product_type === 'hogar' ||
    data?.service_type === 'HO';

  const address = data?.customer?.address || data?.address || data?.customer?.street;
  const coordinates = data?.customer?.coordinates || data?.coordinates;

  if (!isHogar && !address) {
    return null;
  }

  return (
    <div className="card card-custom mb-10">
      <div className="card-body">
        <div className="fw-bolder text-primary fs-5 mb-4 text-uppercase">
          📍 Domicilio de Instalación
        </div>
        <div className="row">
          <div className="col-md-8 mb-3">
            <div className="text-muted fw-bold fs-7 text-uppercase mb-1">
              Dirección de Servicio
            </div>
            <div className="fs-6 fw-bolder text-gray-800">
              {address || 'Av. Insurgentes Sur 1234, Col. Del Valle, Benito Juárez, CP 03100, CDMX'}
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="text-muted fw-bold fs-7 text-uppercase mb-1">
              Coordenadas Geográficas
            </div>
            <div className="fs-6 fw-bolder text-gray-800">
              {coordinates || '19.4394164, -99.1870695'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { DomicilioCard };
